import { RouteReuseStrategy, ActivatedRouteSnapshot, DetachedRouteHandle } from "@angular/router";




/** Interface for object which can store both:
 * An ActivatedRouteSnapshot, which is useful for determining whether or not you should attach a route (see this.shouldAttach)
 * A DetachedRouteHandle, which is offered up by this.retrieve, in the case that you do want to attach the stored route
 * https://stackoverflow.com/questions/41280471/how-to-implement-routereusestrategy-shoulddetach-for-specific-routes-in-angular?rq=1
 */
interface RouteStorageObject {
    snapshot: ActivatedRouteSnapshot;
    handle: DetachedRouteHandle;
}

export class SpotterRouteReuseStrategy implements RouteReuseStrategy {
    storedRoutes: { [key: string]: RouteStorageObject } = {};
    private acceptedRoutes: string[] = [
        "explore/map", "explore/grid",
        "absence/map", "absence/grid",
        "admin/data", "data/species/:speciesid"
    ];

    shouldDetach(route: ActivatedRouteSnapshot): boolean {
        return (this.acceptedRoutes.indexOf(route.routeConfig!.path!) > -1)
    }


    store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
        let storedRoute: RouteStorageObject = {
            snapshot: route,
            handle: handle
        };
        this.storedRoutes[route.routeConfig!.path!] = storedRoute;
    }

    shouldAttach(route: ActivatedRouteSnapshot): boolean {
        return !!this.storedRoutes[route.routeConfig!.path!];
    }

    retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
        if (!route.routeConfig || !this.storedRoutes[route.routeConfig!.path!])
            return null;

        return this.storedRoutes[route.routeConfig!.path!].handle;
    }


    shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        return future.routeConfig === curr.routeConfig;
    }
}
